import { botTypes } from '../types';

import { Departments } from '@/types';

export const SUB_DEPARTMENTS: Record<botTypes.SubDepartments, string> = {
  test: 'Тестовое подразделение',
  tr_1: 'Отдел № 1',
  tr_2: 'Отдел № 2',
  tr_3: 'Отдел № 3',
  tr_4: 'Отдел № 4',
  tr_call: 'Отдел Звонков',
  en_1: 'Отдел № 1',
  la_1: 'ОПЛА №1',
  la_2: 'ОПЛА №2',
  la_3: 'ОПЛА №3',
  br_1: 'Отдел № 1',
  ru_1: 'Отдел № 1',
  ru_2: 'Отдел № 2',
  ru_3: 'Отдел № 3',
  ru_4: 'Отдел № 4',
  ru_opk_1: 'ОПК 1',
  ru_opk_2: 'ОПК 2',
  ru_opk_3: 'ОПК 3',
};

export const DEPARTMENTS_STRUCTURE: Record<Departments, botTypes.SubDepartments[]> = {
  [Departments.tr]: [
    botTypes.SubDepartments.tr_1,
    botTypes.SubDepartments.tr_2,
    botTypes.SubDepartments.tr_3,
    botTypes.SubDepartments.tr_4,
    botTypes.SubDepartments.tr_call,
  ],
  [Departments.en]: [botTypes.SubDepartments.en_1],
  [Departments.la]: [
    botTypes.SubDepartments.la_1,
    botTypes.SubDepartments.la_2,
    botTypes.SubDepartments.la_3,
  ],
  [Departments.br]: [botTypes.SubDepartments.br_1],
  [Departments.ru]: [
    botTypes.SubDepartments.ru_1,
    botTypes.SubDepartments.ru_2,
    botTypes.SubDepartments.ru_3,
    botTypes.SubDepartments.ru_4,
    botTypes.SubDepartments.ru_opk_1,
    botTypes.SubDepartments.ru_opk_2,
    botTypes.SubDepartments.ru_opk_3,
  ],
};
